import React from 'react'
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {PrimaryButton, SuccessButton} from "./Button";
import moment from "moment";

const FormGroup = styled.div`
  width: 100%;
  & .form-control {
    width: 100% !important;
    height: 38px;
  }
`;

export default class FileUploader extends React.Component {
  state = {
    file: null,
    //we can't control file inputs in React. So we need to trick React into rendering a new input when we change this key.
    key: moment().toISOString()
  };

  uploadFile = (e) => {
    e.preventDefault();
    const {file} = this.state;
    this.setState({file: null, key: moment().toISOString()}, () => this.props.onUpload(file));
  };

  onFileSelected = ({currentTarget: {files}}) =>
    this.setState({file: files[0]});

  normalizeFileTypes = () =>
    this.props.fileTypes.map(x => x.startsWith('.') ? x : `.${x}`);

  render() {
    const {file, key} = this.state;
    const {cancel, className} = this.props;
    const fileTypes = this.normalizeFileTypes();
    return (
      <div className={className}>
        <div className="row">
          <div className="col-sm-12">
            <label htmlFor="file-uploader">
              File Upload (Accepted file types: {fileTypes.join(', ').toLocaleUpperCase()})
            </label>
          </div>
        </div>
        <div className="row form-inline">
          <div className="col-sm-9">
            <FormGroup className="form-group">
              <input
                key={key}
                type="file"
                id="file-uploader"
                accept={fileTypes}
                className="form-control"
                onChange={this.onFileSelected}
              />
            </FormGroup>
          </div>
          <div className="col-sm-3">
            <SuccessButton disabled={!file} onClick={this.uploadFile}>
              <i className="fa fa-upload" aria-hidden="true"/> Upload
            </SuccessButton>
            {cancel && <PrimaryButton onClick={cancel}/>}
          </div>
        </div>
      </div>
    )
  }
}

FileUploader.defaultProps = {
  cancel: null
};

FileUploader.propTypes = {
  onUpload: PropTypes.func.isRequired,
  fileTypes: PropTypes.array.isRequired,
  cancel: PropTypes.func,
};


// WEBPACK FOOTER //
// ./src/components/FileUploader.js